import { render, staticRenderFns } from "./user-tag-new.vue?vue&type=template&id=347c977c"
import script from "./user-tag-new.vue?vue&type=script&lang=js"
export * from "./user-tag-new.vue?vue&type=script&lang=js"
import style0 from "./user-tag-new.vue?vue&type=style&index=0&id=347c977c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports